import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/ORDER`;

export const REDUCER_NAME = 'order';

export const PDF_URL = `${SHIPPING_EDGE}/api/shipments/print-shipments-pdf`;

export const TRACKING_ENDPOINT = `${SHIPPING_EDGE}/api/shipments/trackshipment`;

export const ROUTES = {
  ROOT: '/order/:oId',
};
